import { useMemo, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { Swiper, SwiperSlide } from 'swiper/react';
import useScreenSize from '../../core/hooks/useScreenSize';
import CategoryLink from '../CategoryLink/CategoryLink';
import Wrapper from '../common/Wrapper/Wrapper';
import FullscreenSlider from '../FullscreenSlider/FullscreenSlider';
import { Icon } from '../common/Icons';
import {
  StyledContainer,
  StyledButton,
  StyledImage,
  StyledPrevButton,
  StyledNextButton,
} from './PortraitSlider.styles.js';

function PortraitSlider({ slides }) {
  if (!slides) return null;

  const [fullscreenActive, setFullscreenActive] = useState(0);
  const [size] = useScreenSize();
  const desktopWidth = useMemo(() => size > 991, [size]);
  const swiperRef = useRef(null);

  const onClick = clickedId => setFullscreenActive(clickedId);

  const onSlideButtonClick = direction => {
    switch (direction) {
      case 'prev':
        swiperRef.current.swiper.slidePrev();
        break;
      case 'next':
        swiperRef.current.swiper.slideNext();
        break;
      default:
        return null;
    }
  };

  return (
    <StyledContainer>
      <Wrapper>
        {slides.category && (
          <CategoryLink
            link={slides.category.link ? slides.category.link : '/'}
            color={slides.category.color && slides.category.color}
            name={slides.category.name && slides.category.name}
          />
        )}
      </Wrapper>
      {slides.images && (
        <Swiper
          ref={swiperRef}
          spaceBetween={10}
          slidesPerView="auto"
          slidesOffsetBefore={desktopWidth ? 0 : 26}
          slidesOffsetAfter={26}
        >
          {slides.images.map(image => (
            <SwiperSlide key={image.id}>
              <StyledButton onClick={() => onClick(image.id)}>
                {image.url && (
                  <StyledImage
                    src={image.url ? image.url : ''}
                    alt={image.alt ? image.alt : 'Image alt'}
                  />
                )}
              </StyledButton>
            </SwiperSlide>
          ))}
        </Swiper>
      )}
      {desktopWidth && (
        <>
          <StyledPrevButton onClick={() => onSlideButtonClick('prev')}>
            <Icon.PrevSlide />
          </StyledPrevButton>
          <StyledNextButton onClick={() => onSlideButtonClick('next')}>
            <Icon.NextSlide />
          </StyledNextButton>
        </>
      )}
      {fullscreenActive ? (
        <FullscreenSlider
          slides={slides.images}
          clickedId={fullscreenActive}
          closeFullscreen={() => setFullscreenActive(0)}
        />
      ) : null}
    </StyledContainer>
  );
}

PortraitSlider.propTypes = {
  slides: PropTypes.shape({
    category: PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string,
      color: PropTypes.string,
      link: PropTypes.string.isRequired,
    }),
    images: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number.isRequired,
        url: PropTypes.string.isRequired,
        alt: PropTypes.string,
        category: PropTypes.string,
      })
    ),
  }),
};

export default PortraitSlider;
